import React, { useContext, useState } from 'react';
import { Button, Card, Container, Row, Col } from 'react-bootstrap';
import { FaCheck, FaRegCopy } from 'react-icons/fa';
import { AuthContextProvider } from '../../AuthContext/AuthContext';
import referalgift from '../../assets/images/new/referalgift.png'
import './ReferAndEarn.css'
import LoginPopUp from '../LoginPopup';
const ReferAndEarn = () => {
    const userID = localStorage.getItem("userID") || "";
    const referralCode = localStorage.getItem("referralID");
    const [copied, setCopied] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(referralCode);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };
    const handleShare = () => {
        if (userID === null || userID === undefined || userID === '') {
            setShowLoginModal(true)
        } else {
            const url = `https://myomnamo.com/Register?RefCode=${referralCode}&From=webapp`;
            // const url = `https://myomnamo-new.vercel.app/Register?RefCode=${referralCode}&From=webapp`;
            const whatsappURL = `https://wa.me/?text=${encodeURIComponent(
                `Welcome, Friend!\n Create your account to explore a divine collection of spiritual products and sacred services.
              Everything you need for your spiritual journey is here.\n Start your journey with Myomnamo today!\n Use my referral code:\n${url}`
            )}`;


            window.open(whatsappURL, "_blank");
        }

    };
    return (
        <>

            <Container className="py-1" style={{ width: '100%' }}>
                <Card className="shadow-sm border-0">
                    <Card.Body className='mt-5'>
                        <Row className="align-items-center">
                            {/* Image Section */}
                            <Col xs={12} md={6} className="text-center mb-4 mb-md-0">
                                <div className="slide-in-left">
                                    <img
                                        src={referalgift}
                                        alt="Refer and Earn"
                                        className="img-fluid rounded responsive-img"
                                        style={{ width: '85%' }}
                                    />
                                </div>
                            </Col>

                            {/* Text Section */}
                            <Col xs={12} md={6}>
                                <div className="slide-in-right">
                                    <h2 className="mb-3 fw-bold text-center text-md-start ">Refer & Earn</h2>
                                    <p className=" text-center text-md-start">
                                        <strong>Invite Your Friends & Earn ₹101! </strong><br />
                                        Share Myomnamo with your friends — you’ll receive ₹101 when they log in for the first time! <br />
                                        Let’s grow our spiritual community together.
                                    </p>
                                    {(referralCode !== null && referralCode !== undefined && referralCode !== '') && (
                                        <div className="d-flex justify-content-center justify-content-md-start align-items-center flex-wrap gap-2 my-3">
                                            <div className="border rounded px-3 py-2 bg-light fw-bold">
                                                Your Referral Code: <span className="text-secondary">{referralCode}</span>
                                            </div>
                                            {/* <button className="Normal-app-btn px-3" style={{ fontSize: '14px' }} onClick={handleCopy}>
  {copied ? <FaCheck /> : <FaRegCopy />}
</button> */}
                                        </div>
                                    )}


                                    <div className="text-center text-md-start d-flex justify-content-md-start justify-content-center">

                                        <button className="careox-btn mt-1" style={{ minWidth: '150px' }} onClick={handleShare}>
                                            Invite Now
                                        </button>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Container>
            <LoginPopUp show={showLoginModal} onHide={() => setShowLoginModal(false)} />
        </>


    );
};

export default ReferAndEarn;
